import React from 'react'
import { graphql } from 'gatsby'
import { MDXProvider } from '@mdx-js/react'
import { MDXRenderer } from 'gatsby-plugin-mdx'

import Layout from '../components/Layout'
import shortcodes from '../components/shortcodes'
import SEO from '../components/SEO'

export default ({ data = {}, path, ...props }) => {
  const { image, seo_title, title } = data.mdx.frontmatter
  const seoTitle = seo_title || title
  const heroImage = image || 'koln-skyline-2000x1000.jpg'

  return (
    <>
      <SEO tag="title">{seoTitle}</SEO>
      <Layout {...data.mdx.frontmatter} image={heroImage}>
        <MDXProvider components={shortcodes}>
          <MDXRenderer>{data.mdx.body}</MDXRenderer>
        </MDXProvider>
      </Layout>
    </>
  )
}

export const pageQuery = graphql`
  query PageQuery($mdxId: String!) {
    mdx(id: { eq: $mdxId }) {
      body
      frontmatter {
        title
        seo_title
        subtitle
        image
        slug
      }
    }
  }
`
